import React, { FC } from 'react';
import { GxTabPanel } from '@garpix/garpix-web-components-react';

import StatisticPanelTable from './StatisticsPanelTable';

import 'react-responsive-modal/styles.css';
import styles from '../../styles/index.module.scss';

const StatisticsPanel: FC<any> = ({ userId }) => (
  <GxTabPanel name='statistics'>
    <div className={styles['statistics']}>
      <StatisticPanelTable userId={userId} />
    </div>
  </GxTabPanel>
);

export default StatisticsPanel;
